import { client } from './api';
import { downloadResponseAsFile } from '../utils/downloadFile';

export interface CahpsExportListItem {
  id: string;
  sample_month: number;
  sample_year: number;
  file_name: string;
  row_count: number;
  generated_by: string | null;
  created_at: string;
}

interface CahpsExportListResponse {
  exports: CahpsExportListItem[];
}

export async function listCahpsExports(): Promise<CahpsExportListItem[]> {
  const response = await client.get<CahpsExportListResponse, unknown, true>({
    responseType: 'json',
    throwOnError: true,
    url: '/cahps-exports',
  });
  return response.data.exports;
}

export async function generateCahpsExport(
  sampleMonth: number,
  sampleYear: number
): Promise<void> {
  const response = await client.post<Blob, unknown, true>({
    query: { sample_month: sampleMonth, sample_year: sampleYear },
    responseType: 'blob',
    throwOnError: true,
    url: '/cahps-exports/generate',
  });
  downloadResponseAsFile(
    response,
    `HHCAHPS_${sampleYear}_${String(sampleMonth).padStart(2, '0')}.csv`
  );
}

export async function downloadCahpsExport(
  exportId: string,
  fallbackFilename: string
): Promise<void> {
  const response = await client.get<Blob, unknown, true>({
    path: { export_id: exportId },
    responseType: 'blob',
    throwOnError: true,
    url: '/cahps-exports/{export_id}/download',
  });
  downloadResponseAsFile(response, fallbackFilename);
}
